// extracted by mini-css-extract-plugin
export var sliderRange = "_pj-2";
export var sliderRoot = "_pj-0";
export var sliderThumb = "_pj-3";
export var sliderTrack = "_pj-1";